import React from "react";

import {
  TIMESTAMP_FORMAT_LABELS,
  type TimestampFormat,
  useTimestampFormat,
} from "@/shared/components/RobotoMarkdown/timeFormat";
import { LinkButton } from "@/shared/foundation/primitives";

import styles from "./TimeFormatSettingLink.module.css";

/**
 * Renders an AI-emitted `roboto://ui/time-format?format=<fmt>` link as a button
 * that switches the timestamp display format — a preference change, not
 * navigation. Outside a TimestampFormatProvider there is no `setFormat`, so it
 * degrades to the plain label rather than a dead button.
 */
export const TimeFormatSettingLink: React.FC<
  React.PropsWithChildren<{ format: TimestampFormat }>
> = ({ format, children }) => {
  const ctx = useTimestampFormat();
  if (ctx === undefined) {
    return <>{children}</>;
  }

  return (
    <LinkButton
      className={styles.chip}
      onClick={() => ctx.setFormat(format)}
      aria-pressed={ctx.format === format}
      title={`Display all timestamps as ${TIMESTAMP_FORMAT_LABELS[format]}`}
    >
      {children}
    </LinkButton>
  );
};
